<template>
    <div class="main">
        <div class="subTitle">
        <el-link
            icon="el-icon-arrow-left"
            :underline="false"
            href="#/genericContents"
            >Content Management - Generic Contents</el-link
        >
        </div>
        <h3 class="title" content="edit" placement="bottom">
        Create Generic Contents
        </h3>
        <generic-content-form @setFormValue="getForm($event)" @getIsValid="getIsValid($event)" :validate="triggerValidate"></generic-content-form>
        <el-row style="padding: 25px 0" type="flex" justify="end" :gutter="20">
            <el-col :span="4">
            <el-button v-if="showSave" class="reset" style="width: 100%" @click="handleCancel"
                >Cancel</el-button
            >
            </el-col>
            <el-col :span="4">
            <el-button
                v-if="showSave"
                type="primary"
                style="width: 100%"
                @click="handleCreate"
                >Create</el-button
            >
            </el-col>
        </el-row>
    </div>
</template>
  
<script>
import { genericContentAdd } from '../../../request/api';
import GenericContentForm from './genericContentForm.vue';

    export default {
        name: "genericContentCreate",
        data() {
            return {
                showSave: true,
                formGenericContent:null,
                triggerValidate: false,
                isFormValid: false
            };
        },
        components:{
            "generic-content-form" : GenericContentForm
        },
        methods: {
            handleCreate(){
                this.triggerValidate = !this.triggerValidate;
                setTimeout(() => {
                    if(this.isFormValid){
                        genericContentAdd(this.formGenericContent).then((res)=>{
                            if (res.data.status == "00") {
                                
                                this.$message.success("New record is created");
                                this.handleCancel();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        })
                    }
                }, 500);
            },
            handleCancel(){
                this.$router.push("/genericContents");
            },
            getForm(form){
                this.formGenericContent = form
            },
            getIsValid(valid){
                this.isFormValid = valid; 
            },
        },
    }
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
  margin-right: 10px !important;
}
.el-row:last-child {
  margin-bottom: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/content/genericContent/genericContentCreate.vue